module.exports = __webpack_public_path__ + "img/audit.41248eef.png";